<template>
  <div>
    <base-table
      class="custom-table"
      tableClass="table-bordered"
      hidePagination
    >
      <template #thead>
        <thead>
          <tr>
            <th>{{ $t('apps.settings.message.application') }}</th>
            <th>{{ $t('apps.settings.message.module') }}</th>
            <th>{{ $t('apps.settings.message.submodule') }}</th>
            <th>
              <div class="d-flex justify-content-center">
                <span class="mr-2">
                  {{ $t('apps.settings.message.installstatus') }}
                </span>
                <vs-tooltip
                  :text="$t('apps.settings.message.installstatushint')"
                  position="top"
                >
                  <i class="fas fa-info-circle"/>
                </vs-tooltip>
              </div>
            </th>
            <th class="text-center">{{ $t('apps.settings.message.view') }}</th>
            <th class="text-center">{{ $t('apps.settings.message.create') }}</th>
            <th class="text-center">{{ $t('apps.settings.message.update') }}</th>
            <th class="text-center">{{ $t('apps.settings.message.approve') }}</th>
            <th class="text-center">{{ $t('apps.settings.message.delete') }}</th>
          </tr>
        </thead>
      </template>
      <template #tbody>
        <tbody>
          <tr
            v-for="(row, rowIndex) in rows"
            :key="rowIndex"
          >
            <td
              v-if="row.a.value"
              :rowspan="row.a.rowspan"
            >
              {{ $t(`apps.settings.permission.appid${row.key.appId}`) }}
            </td>
            <td
              v-if="row.b.value"
              :rowspan="row.b.rowspan"
            >
              {{ $t(`apps.settings.permission.${getTranslateKey(row.key, { isSubModule: false })}`) }}
            </td>
            <td
              :rowspan="row.c.rowspan"
            >
              {{ row.c.value ? $t(`apps.settings.permission.${getTranslateKey(row.key, { isSubModule: true })}`) : null }}
            </td>
            <td class="text-center">
              <i
                :class="[
                  'fas fa-cloud-download-alt',
                  row.key.isInstalled ? 'text-success' : 'text-danger',
                ]"
                style="font-size: 20px;"
              />
            </td>
            <td>
              <div
                v-if="row.action.view"
                class="d-flex flex-column justify-content-center align-items-center w-100"
                style="gap: 4px;"
              >
                <BaseCheckbox
                  :value="checkboxs[getCheckBoxKey(row.key, 'view')]"
                  :disabled="checkboxsDisabled[getCheckBoxKey(row.key, 'view')] || !row.key.isInstalled"
                  color="#A3CA76"
                  style="position: relative;left: 4px;"
                  @change="handleCheckBoxValueChange($event, row.key, row.action, 'view')"
                />
                <div
                  v-if="getMetadata(row.key.appId, row.key.moduleId, row.key.subModuleId)"
                  class="w-100">
                  <button
                    :disabled="!checkboxs[getCheckBoxKey(row.key, 'view')]"
                    class="btn btn-sm btn-light d-flex flex-column align-items-center w-100"
                    @click="handleClickSettings(row.key.appId, row.key.moduleId, row.key.subModuleId, checkboxs[getCheckBoxKey(row.key, 'view')], row.key, row.action, 'view')"
                  >
                    {{ row.metadata }}
                    <i class="fas fa-cog"/>
                    <!-- <span>{{ $t('message.settings') }}</span> -->
                  </button>
                </div>
              </div>
            </td>
            <td>
              <div
                v-if="row.action.create"
                class="d-flex justify-content-center w-100">
                <BaseCheckbox
                  :value="checkboxs[getCheckBoxKey(row.key, 'create')]"
                  :disabled="checkboxsDisabled[getCheckBoxKey(row.key, 'create')] || !row.key.isInstalled"
                  color="#A3CA76"
                  style="position: relative;left: 4px;"
                  @change="handleCheckBoxValueChange($event, row.key, row.action, 'create')"
                />
              </div>
            </td>
            <td>
              <div
                v-if="row.action.update"
                class="d-flex justify-content-center w-100">
                <BaseCheckbox
                  :value="checkboxs[getCheckBoxKey(row.key, 'update')]"
                  :disabled="checkboxsDisabled[getCheckBoxKey(row.key, 'update')] || !row.key.isInstalled"
                  color="#A3CA76"
                  style="position: relative;left: 4px;"
                  @change="handleCheckBoxValueChange($event, row.key, row.action, 'update')"
                />
              </div>
            </td>
            <td>
              <div
                v-if="row.action.approve"
                class="d-flex justify-content-center w-100">
                <BaseCheckbox
                  :value="checkboxs[getCheckBoxKey(row.key, 'approve')]"
                  :disabled="checkboxsDisabled[getCheckBoxKey(row.key, 'approve')] || !row.key.isInstalled"
                  color="#A3CA76"
                  style="position: relative;left: 4px;"
                  @change="handleCheckBoxValueChange($event, row.key, row.action, 'approve')"
                />
              </div>
            </td>
            <td>
              <div
                v-if="row.action.delete"
                class="d-flex justify-content-center w-100">
                <BaseCheckbox
                  :value="checkboxs[getCheckBoxKey(row.key, 'delete')]"
                  :disabled="checkboxsDisabled[getCheckBoxKey(row.key, 'delete')] || !row.key.isInstalled"
                  color="#A3CA76"
                  style="position: relative;left: 4px;"
                  @change="handleCheckBoxValueChange($event, row.key, row.action, 'delete')"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </base-table>

    <!--
      APP_ID 8, MODULE_ID 2, SUB_MODULE_ID 1 (Report -> POS -> Sales)
    -->
    <BaseModalPermissionSetting
      v-if="dataModal.app_id == 8 && dataModal.module_id == 2 && [1,2,3,4,5,6].includes(dataModal.submodule_id)"
      :id="`VIEW_APPID${dataModal.app_id}_MODULEID${dataModal.module_id}_SUBMODULEID${dataModal.submodule_id}`"
      :data-modal="dataModal"
      @onCancel="handleCancelSettingModal"
      @onSubmit="handleSubmitSettingModal"
    >
      <div
        v-if="dataModal.metadata"
        class="row">
        <div class="form-group col-12 mb-0">
          <section-title :title="`การแสดงผล`"/>
          <div
            class="d-flex flex-column"
            style="gap: 6px;">
            <BaseCheckbox
              v-if="dataModal.metadata.view.fields.cost != null"
              v-model="dataModal.metadata.view.fields.cost"
              :label="`ต้นทุน`"
            />
            <BaseCheckbox
              v-if="dataModal.metadata.view.fields.discount != null"
              v-model="dataModal.metadata.view.fields.discount"
              :label="`ส่วนลด`"
            />
            <BaseCheckbox
              v-if="dataModal.metadata.view.fields.tax != null"
              v-model="dataModal.metadata.view.fields.tax"
              :label="`ภาษี`"
            />
            <BaseCheckbox
              v-if="dataModal.metadata.view.fields.collect != null"
              v-model="dataModal.metadata.view.fields.collect"
              :label="`ยอดขาย`"
            />
            <BaseCheckbox
              v-if="dataModal.metadata.view.fields.refund != null"
              v-model="dataModal.metadata.view.fields.refund"
              :label="`คืนเงิน`"
            />
            <BaseCheckbox
              v-if="dataModal.metadata.view.fields.net != null"
              v-model="dataModal.metadata.view.fields.net"
              :label="`ยอดขายสิทธิ`"
            />
            <BaseCheckbox
              v-if="dataModal.metadata.view.fields.profit != null"
              v-model="dataModal.metadata.view.fields.profit"
              :label="`กำไร`"
            />
          </div>
        </div>
      </div>
    </BaseModalPermissionSetting>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapGetters } from 'vuex'
import BaseModalPermissionSetting from './BaseModalPermissionSetting.vue'

export default {
  components: {
    BaseModalPermissionSetting,
  },

  props: {
    masterData: {
      type: Array,
      default: () => ([]),
    },
    data: {
      type: Array,
      default: () => ([]),
    },
  },

  data () {
    return {
      checkboxs: {},
      checkboxsDisabled: {},
      permissions: [],
      dataModal: {
        id: null,
        app_id: null,
        module_id: null,
        submodule_id: null,
        state: null,
        key: null,
        action: null,
        actionType: null,
        metadata: null,
        metadata_origin: null,
      },
    }
  },

  computed: {
    ...mapGetters([
      'isAppModuleInstalled',
    ]),
    mapAppRolePermissions () {
      return this.masterData.map((app) => {
        const rowspanApp = app.modules.reduce((acc, cur) => {
          if (cur.sub_modules && cur.sub_modules.length) {
            acc += cur.sub_modules.length
          } else {
            acc += 1
          }
          return acc
        }, 0)
        return {
          ...app,
          rowspanApp,
          modules: app.modules.map((module) => {
            const rowspanModule = (() => {
              if (module.sub_modules && module.sub_modules.length) {
                return module.sub_modules.length
              }
              return 1
            })()
            return {
              ...module,
              rowspanModule,
            }
          }),
        }
      })
    },
    rows () {
      return this.mapAppRolePermissions.reduce((acc, cur) => {
        for (let index = 0; index < cur.modules.length; index++) {
          const rowspan = index === 0
            ? cur.rowspanApp
            : cur.modules[index].rowspanModule
          const key = {
            appId: cur.app_id,
            moduleId: cur.modules[index].module_id,
            subModuleId: cur.modules[index].sub_modules && cur.modules[index].sub_modules.length ? cur.modules[index].sub_modules[0].sub_module_id : null,
            isInstalled: this.isAppModuleInstalled(cur.app_id, cur.modules[index].module_id),
          }
          const action = cur.modules[index].action || cur.modules[index].sub_modules[0].action
          const a = {
            rowspan,
            value: index === 0 ? cur.app_name : null,
          }
          const b = {
            rowspan: !a.value ? rowspan : cur.modules[index].rowspanModule,
            value: index === 0 ? cur.modules[0].module_name : cur.modules[index].module_name,
          }
          const c = {
            rowspan: 1,
            value: cur.modules[index].sub_modules && cur.modules[index].sub_modules.length ? cur.modules[index].sub_modules[0].sub_module_name : null,
          }
          acc.push({ rowspan, a, b, c, key, action })
          if (cur.modules[index].sub_modules && cur.modules[index].sub_modules.length) {
            for (let j = 0; j < cur.modules[index].sub_modules.length; j++) {
              if (j === 0) continue
              const rowspan = 1
              const a = {
                rowspan: 1,
                value: null,
              }
              const b = {
                rowspan: 1,
                value: null,
              }
              const c = {
                rowspan: 1,
                value: cur.modules[index].sub_modules[j].sub_module_name,
              }
              const key = {
                appId: cur.app_id,
                moduleId: cur.modules[index].module_id,
                subModuleId: cur.modules[index].sub_modules[j].sub_module_id,
                isInstalled: this.isAppModuleInstalled(cur.app_id, cur.modules[index].module_id),
              }
              const action = cur.modules[index].sub_modules[j].action
              acc.push({ rowspan, a, b, c, key, action })
            }
          }
        }
        return acc
      }, [])
    },
  },

  created () {
    this.initPermissions()
    this.sortPermissions()
    this.cleanPermissions()
  },

  methods: {
    getTranslateKey (key, { isSubModule }) {
      let str = `appid${key.appId}-moduleid${key.moduleId}`
      if (key.subModuleId && isSubModule) {
        str += `-submoduleid${key.subModuleId}`
      }
      return str
    },
    getCheckBoxKey (key, actionType) {
      let str = `appid${key.appId}.moduleid${key.moduleId}`
      if (key.subModuleId) {
        str += `.submoduleid${key.subModuleId}`
      }
      str += `.${actionType}`
      return str
    },
    setCheckBox (state, key, actionType) {
      const propName = this.getCheckBoxKey(key, actionType)
      this.$set(this.checkboxs, propName, state)
    },
    setCheckBoxDisable (state, key, actionType) {
      const propName = this.getCheckBoxKey(key, actionType)
      this.$set(this.checkboxsDisabled, propName, state)
    },
    mapAction (state, action, actionType) {
      return Object.keys(action).reduce((acc, cur) => {
        if (action[cur] !== undefined) {
          acc[cur] = cur === actionType ? state : false
        }
        return acc
      }, {})
    },
    initPermissions () {
      for (const appIndex in this.data) {
        const app = this.data[appIndex]
        for (const moduleIndex in app.modules) {
          const module = app.modules[moduleIndex]
          const key = {
            appId: app.app_id,
            moduleId: module.module_id,
            subModuleId: null,
            metadata: module.metadata,
          }
          if (module.sub_modules && module.sub_modules.length) {
            for (const subModuleIndex in module.sub_modules) {
              const subModule = module.sub_modules[subModuleIndex]
              const action = cloneDeep(subModule.action)
              const metadata = cloneDeep(subModule.metadata)
              key.subModuleId = subModule.sub_module_id
              Object.keys(action).forEach((item, index) => {
                const state = action[item]
                const actionType = item
                this.setPermissions(state, key, action, actionType, metadata)
                this.setCheckBox(state, key, actionType)
                this.checkDisabledViewAction(state, key, action, actionType)
              })
            }
          } else {
            const action = cloneDeep(module.action)
            const metadata = cloneDeep(module.metadata)
            Object.keys(action).forEach((item, index) => {
              const state = action[item]
              const actionType = item
              this.setPermissions(state, key, action, actionType, metadata)
              this.setCheckBox(state, key, actionType)
              this.checkDisabledViewAction(state, key, action, actionType)
            })
          }
        }
      }
    },
    setPermissions (state, key, action, actionType, metadata) {
      const foundAppId = this.permissions.some((item) => item.app_id === key.appId)
      if (!foundAppId) {
        const app = {
          app_id: key.appId,
          modules: [
            {
              module_id: key.moduleId,
              metadata: null,
            },
          ],
        }
        if (!key.subModuleId) {
          app.modules[0].action = this.mapAction(state, action, actionType)
          app.modules[0].metadata = this.getMetadata(key.appId, key.moduleId, null)
        } else {
          app.modules[0].sub_modules = [
            {
              sub_module_id: key.subModuleId,
              action: this.mapAction(state, action, actionType),
              metadata: this.getMetadata(key.appId, key.moduleId, key.subModuleId),
            },
          ]
        }
        this.permissions.push(app)
      } else {
        const permission = this.permissions.find((item) => item.app_id === key.appId)
        const foundAppIdAtIndex = this.permissions.findIndex((item) => item.app_id === key.appId)
        const foundModuleIdAtIndex = permission.modules.findIndex((item) => item.module_id === key.moduleId)
        const foundModuleId = foundModuleIdAtIndex >= 0
        if (foundModuleId) {
          if (!key.subModuleId) {
            this.permissions[foundAppIdAtIndex].modules[foundModuleIdAtIndex].action[actionType] = state
            this.permissions[foundAppIdAtIndex].modules[foundModuleIdAtIndex].metadata = metadata
          } else {
            const foundSubModuleIdAtIndex = permission.modules[foundModuleIdAtIndex].sub_modules.findIndex((item) => item.sub_module_id === key.subModuleId)
            const foundSubModuleId = foundSubModuleIdAtIndex >= 0
            if (foundSubModuleId) {
              this.permissions[foundAppIdAtIndex].modules[foundModuleIdAtIndex].sub_modules[foundSubModuleIdAtIndex].action[actionType] = state
              this.permissions[foundAppIdAtIndex].modules[foundModuleIdAtIndex].sub_modules[foundSubModuleIdAtIndex].metadata = metadata
            } else {
              const subModule = {
                sub_module_id: key.subModuleId,
                action: this.mapAction(state, action, actionType),
                metadata: metadata,
              }
              this.permissions[foundAppIdAtIndex].modules[foundModuleIdAtIndex].sub_modules.push(subModule)
            }
          }
        } else {
          const module = {
            module_id: key.moduleId,
          }
          if (!key.subModuleId) {
            module.action = this.mapAction(state, action, actionType)
            module.metadata = this.getMetadata(key.appId, key.moduleId, key.subModuleId)
          } else {
            module.sub_modules = [
              {
                sub_module_id: key.subModuleId,
                action: this.mapAction(state, action, actionType),
                metadata: this.getMetadata(key.appId, key.moduleId, key.subModuleId),
              },
            ]
          }
          this.permissions[foundAppIdAtIndex].modules.push(module)
        }
      }
    },
    checkDisabledViewAction (state, key, action, actionType) {
      const isCreateUpdateOrDelete = ['create', 'update', 'approve', 'delete'].includes(actionType)
      const setViewAble = action.view === true
      const createCheckbox = this.checkboxs[this.getCheckBoxKey(key, 'create')] || false
      const updateCheckbox = this.checkboxs[this.getCheckBoxKey(key, 'update')] || false
      const approveCheckbox = this.checkboxs[this.getCheckBoxKey(key, 'approve')] || false
      const deleteCheckbox = this.checkboxs[this.getCheckBoxKey(key, 'delete')] || false
      const someActionChecked = createCheckbox || updateCheckbox || approveCheckbox || deleteCheckbox
      if (setViewAble && isCreateUpdateOrDelete) {
        if (someActionChecked) {
          this.setCheckBox(true, key, 'view')
          this.setCheckBoxDisable(true, key, 'view')
          this.setPermissions(true, key, action, 'view')
        } else {
          this.setCheckBoxDisable(false, key, 'view')
        }
      }
    },
    sortPermissions () {
      this.permissions.sort((a, b) => a.app_id - b.app_id)
      for (const index in this.permissions) {
        this.permissions[index].modules.sort((a, b) => a.module_id - b.module_id)
        for (const _index in this.permissions[index].modules) {
          if (this.permissions[index].modules[_index].sub_modules) {
            this.permissions[index].modules[_index].sub_modules.sort((a, b) => a.sub_module_id - b.sub_module_id)
          }
        }
      }
    },
    cleanPermissions () {
      const remove = {}
      this.permissions.forEach((app, appIndex) => {
        remove[app.app_id] = {
          moduleIds: [],
        }
        app.modules.forEach((module, moduleIndex) => {
          if (module.action) {
            const allFalse = Object.keys(module.action).every((item) => module.action[item] === false)
            if (allFalse) {
              remove[app.app_id].moduleIds.push(module.module_id)
            }
          } else {
            remove[app.app_id][module.module_id] = {
              subModuleIds: [],
            }
          }
          if (module.sub_modules) {
            module.sub_modules.forEach((subModule, subModuleIndex) => {
              const allFalse = Object.keys(subModule.action).every((item) => subModule.action[item] === false)
              if (allFalse) {
                remove[app.app_id][module.module_id].subModuleIds.push(subModule.sub_module_id)
              }
            })
          }
        })
      })
      const clonePermissions = cloneDeep(this.permissions)
      this.permissions = clonePermissions.reduce((acc, cur) => {
        const mapRemove = remove[cur.app_id]
        const app = {
          ...cur,
          modules: cur.modules.reduce((_acc, _cur) => {
            if (!mapRemove.moduleIds.includes(_cur.module_id)) {
              const module = cloneDeep(_cur)
              if (module.sub_modules) {
                module.sub_modules = module.sub_modules.filter((item) => !mapRemove[_cur.module_id].subModuleIds.includes(item.sub_module_id))
              }
              if (module.sub_modules && module.sub_modules.length) {
                _acc.push(module)
              } else if (!module.sub_modules) {
                _acc.push(module)
              }
            }
            return _acc
          }, []),
        }
        if (app.modules.length) {
          acc.push(app)
        }
        return acc
      }, [])
    },
    handleCheckBoxValueChange (state = false, key = {}, action = {}, actionType = '') {
      this.setCheckBox(state, key, actionType)
      this.setCheckBoxDisable(false, key, actionType)
      this.setPermissions(...arguments)
      this.checkDisabledViewAction(...arguments)
      this.sortPermissions()
      this.cleanPermissions()
      this.$emit('update:data', this.permissions)
    },
    handleClickSettings(appId, moduleId, submoduleId, state = false, key = {}, action = {}, actionType = '') {
      let modalId = null
      if (submoduleId) {
        modalId = `${actionType.toUpperCase()}_APPID${appId}_MODULEID${moduleId}_SUBMODULEID${submoduleId}`
      } else {
        modalId = `${actionType.toUpperCase()}_APPID${appId}_MODULEID${moduleId}}`
      }

      this.dataModal.id = modalId
      this.dataModal.app_id = appId
      this.dataModal.module_id = moduleId
      this.dataModal.submodule_id = submoduleId
      this.dataModal.state = state
      this.dataModal.key = key
      this.dataModal.action = action
      this.dataModal.actionType = actionType
      this.dataModal.metadata = cloneDeep(this.getMetadata(appId, moduleId, submoduleId))
      this.dataModal.metadata_origin = cloneDeep(this.dataModal.metadata)

      this.$nextTick(() => {
        this.$bvModal.show(modalId)
      })
    },
    getMetadata(appId, moduleId, submoduleId) {
      // getting from exist permissions first
      for (const permission of this.permissions) {
        if (permission.app_id == appId) {
          for (const module of permission.modules) {
            if (module.module_id == moduleId) {
              if (module.sub_modules && module.sub_modules.length) {
                for (const submodule of module.sub_modules) {
                  if (submodule.sub_module_id == submoduleId && submodule.metadata) {
                    return submodule.metadata
                  }
                }
              } else if (module.metadata) {
                return metadata.metadata
              }
            }
          }
        }
      }

      // if not found, getting from master data
      for (const app of this.masterData) {
        if (app.app_id == appId) {
          for (const module of app.modules) {
            if (module.module_id == moduleId) {
              if (submoduleId == null) {
                return module.metadata
              } else {
                if (module.sub_modules) {
                  for (const submodule of module.sub_modules) {
                    if (submodule.sub_module_id == submoduleId) {
                      return submodule.metadata
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    handleCancelSettingModal(ok) {
      this.dataModal.metadata = cloneDeep(this.dataModal.metadata_origin)
      ok()
    },
    handleSubmitSettingModal(ok) {
      this.setPermissions(
        this.dataModal.state,
        this.dataModal.key,
        this.dataModal.action,
        this.dataModal.actionType,
        this.dataModal.metadata
      )
      this.$emit('update:data', this.permissions)
      ok()
    },
  },
}
</script>

<style scoped>
.custom-table /deep/ .table tr:hover {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseRolePermission.vue